import { render } from "./IconCopy.vue?vue&type=template&id=8e7f65bc"
const script = {}

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__